<script>
  /**
 *
 *
 */

  /*                */
  let { formattedPrice } = $props();
  const priceMode = formattedPrice.priceMode || 'StatusQuo';

  const shouldOriginalPriceBeStrikeThrough = () => {
    return ['StatusQuo', 'Strike', 'StrikeRed'].includes(priceMode);
  };

  const shouldRetailPriceBeRed = () => {
    return (
      formattedPrice.originalPrice &&
      formattedPrice.originalPrice !== formattedPrice.retailPrice &&
      ['StatusQuo', 'Red', 'StrikeRed'].includes(priceMode)
    );
  };
</script>

<div
  data-testid="retailPrice"
  class="oc-copy-75 oc-copy--bold"
  class:color-red={shouldRetailPriceBeRed()}>
  <span class="reco_aos_no_underline_price">{formattedPrice.retailPrice}</span>
</div>
{#if formattedPrice.originalPrice && formattedPrice.originalPrice !== formattedPrice.retailPrice}
  <div data-testid="originalPricePrefix" class="oc-copy-75 color-grey">
    {#if formattedPrice.originalPricePrefix}
      {formattedPrice.originalPricePrefix}
    {/if}
    <span data-testid="originalPrice" class:line-through={shouldOriginalPriceBeStrikeThrough()}
      >{formattedPrice.originalPrice}</span>
  </div>
{/if}

<style lang="scss">
  .reco_aos_no_underline_price {
    display: inline-block;
  }

  .line-through {
    text-decoration: line-through;
  }

  .color-red {
    color: var(--oc-semantic-color-brand);
  }

  .color-grey {
    color: var(--oc-semantic-color-text-default);
  }
</style>
